/** Left padding (px) for version + Details + steps under a lesson (aligned; no extra step indent) */
export const VERSION_ROW_PAD = 96;

/** Drag handle column — used with VERSION_ROW_PAD for nested step / sub-step rows */
export const TREE_DRAG_COLUMN_WIDTH = 20;

export const CONTENT_ITEM_ROW_PAD = 36;
/**
 * Program row: outer indent is 8px (after the 8px green accent). Main adds 6px so label aligns with nav (8+6=14px vs tree padding).
 * Green accent is set in programDetails.css (matches .pd-sidebar-nav-accent).
 */
export const PROGRAM_TREE_NODE_PAD = 8;
/** Left padding (px) for unit rows in the content sidebar tree (smaller than default 14 + level×12). */
export const UNIT_TREE_NODE_PAD = 8;

/**
 * Each level of units inside units indents by this much, so a group's row lands exactly where a
 * lesson row of the same unit would and its own rows sit one step further in.
 */
export const UNIT_TREE_NESTED_PAD_STEP = CONTENT_ITEM_ROW_PAD - UNIT_TREE_NODE_PAD;

/** Indented "Details" under a step row when the step row has a drag handle */
export const TREE_DETAILS_CHILD_PAD = VERSION_ROW_PAD + TREE_DRAG_COLUMN_WIDTH;

/** Sub-steps sit one level under step rows; their Details / goals / memory nest one level further */
export const SUBSTEP_ROW_PAD = VERSION_ROW_PAD + TREE_DRAG_COLUMN_WIDTH;
export const SUBSTEP_NESTED_PAD = SUBSTEP_ROW_PAD + TREE_DRAG_COLUMN_WIDTH;
